export enum TagCategories {
  FR = 'FR',
  RESPONSES = 'Responses',
  NOTES = 'Notes',
}
